import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {
  selectLoadingMonitorData, getLoadingDetailsAsync, 
} from './loadingMonitorSlice';
import styled from 'styled-components'
import { useTable, useRowSelect, usePagination } from 'react-table'
import Modal from 'react-modal';
import styles from './loadingMonitor.module.css';


const Styled = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;
    color : white;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`


function Table({ columns, data }) {
  const dispatch = useDispatch();


  const [showID, setShowID] = useState('');
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    selectedFlatRows,
    pageOptions,
    prepareRow,
    state: { pageIndex, pageSize, selectedRowIds },
  } = useTable(
    {
      columns,
      data,
    },
    usePagination,
    useRowSelect,
    hooks => {
      hooks.visibleColumns.push(columns => [
        // Let's make a column for selection
        {
          id: 'selection',
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div key={'displayViewNoBtn'}>
              View
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (

                <button key = {`btn{row}`} 
                        value={row} onClick={()=>
                        { setShowIDWithData(row.id,row.original.id)
                          console.log('clicked on row.id ' + row.original.id) 
                        console.log('clicked')
                        //alert(row.id)
                        }
                      }>
                      View
                    </button>

          ),
        },

        ...columns,
      ])
    }
  )


  const setShowIDWithData = (id,actualId) => {
    let orm ='';
    let j = '';
    let oru = '';
    let msh = '';
    let display = '';
    if (data[id].hasOwnProperty('orm')) {
      orm = data[id].orm.replaceAll("\",","\",\r\n");
      j = JSON.parse(data[id].orm)['ORMMessage'];
      msh = ((j !== undefined) && (j.length > 0)) ? j.replaceAll("|","|\r\n") : 'Missing MSH';
      display = orm + "\r\n\r\n" + msh;
    }
    else if (data[id].hasOwnProperty('oru')) {
      oru = data[id].oru.replaceAll("\",","\",\r\n");
      console.log(data[id].oru)
      j = JSON.parse(data[id].oru)['ORMMessage'];
      msh = ((j !== undefined) && (j.length > 0)) ? j.replaceAll("|","|\r\n") : 'Missing MSH';
      display = oru + "\r\n\r\n" + msh;
    }
    display = JSON.stringify(data[id])
    setShowID({id,display,actualId});
  } 

  // Render the UI for your table
  return (
    <React.Fragment>


<div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
  

      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>

      <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <span>
          | Go to page:{' '}
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '100px' }}
          />
        </span>{' '}
        <select
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
 
      </div>


      <Modal 
      isOpen={(showID) ? true : false} 
      ariaHideApp={false}
      >
      <button 
        key='setShowIDbtn' 
        onClick={()=>setShowID('')
        }
      >
        Close
      </button>
      <button key='resendOrmBtn' 
        onClick={()=>{
          dispatch(getLoadingDetailsAsync(showID.actualId))
          console.log('resending')} 
        }
      >
        Resend to DocPanel
      </button> 

                          <div>
                          <pre>
                        {
                        (showID) ?  
                        
                        showID.display
                        
                        
                        : ''
                      }
                        </pre>
                        </div>
                        
                        </Modal>
      
      
    </React.Fragment>
  )
}

function DisplayTable() {

  let  { loadingMonitorData }  = useSelector(selectLoadingMonitorData);
  
  const columns = React.useMemo(
    ( sweepsData) => [
      {
        Header: 'created_at',
        accessor:'created_at',
        columns: [
          {
            Header: 'created_at',
            accessor: 'created_at',
          },
          {
            Header: 'Case Number',
            accessor: 'case_number',
          },
          {
            Header: 'Status',
            accessor: 'viewer_status',
          },
        ],
      },
    ],
    []
  )

  

  let loadingCount = loadingMonitorData.length
  let newestInLoading = (loadingMonitorData.length < 1) ? "" : loadingMonitorData[0]['created_at'];
  let newestInLoadingCaseNo = (loadingMonitorData.length < 1) ? "" : loadingMonitorData[0]['case_number'];
  let oldestInLoading = (loadingMonitorData.length < 1) ? "" : loadingMonitorData[loadingCount-1]['created_at'];
  let oldestInLoadingCaseNo = (loadingMonitorData.length < 1) ? "" : loadingMonitorData[loadingCount-1]['case_number'];

  return (
    <Styled>
      {
     (loadingMonitorData.length < 1) ? "" : <div>Total in Loading: {loadingCount}
     <br/>
     Oldest in Loading: {oldestInLoading} Case # {oldestInLoadingCaseNo}
     <br/>
     Newest in Loading: {newestInLoading} Case # {newestInLoadingCaseNo}
     </div>
      }
     {
      (loadingMonitorData.length < 1) ? <div className={styles.rowWhite}> 
  'No Records Found'</div> : <Table columns={columns} data={loadingMonitorData} />}
    </Styled>
  )
}

export default DisplayTable